import { Store } from 'redux';
import { AppActions, AppState } from '../../store/initialStateRegistration';
import {
    injectButtonToMenu,
    injectVideoLogo,
    InjectVideoLogoParams,
} from '../../store/primaryHeader/primaryHeader.actions';
import {
    GET_PAGE_DATA,
    INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY,
    INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
    INJECT_BUTTON_TO_MENU,
    INJECT_VIDEO_LOGO,
} from './index';
import {
    InjectArticleBlockByIndexArrayParams,
    injectArticleBlockByIndexArray,
} from '../../store/template/postPage/postPage.actions';
import { getLanguage, getPageType, getSiteName } from '../../store/config/config.selectors';
import { getArticleId, getBlockNames, getCommercialTags } from '../../store/template/postPage/postPage.selectors';
import {
    injectButtonToFooterLinksSection,
} from '../../store/footer/footer.actions';
import { getCountryCode } from '../../templates/templates.utils';
import { InjectButtonParams } from '../../store/utils/oldNavigation.utils';

const createPageData = (state: AppState) => ({
    siteName: getSiteName(state),
    countryCode: getCountryCode(),
    blockNames: getBlockNames(state),
    language: getLanguage(state),
    tags: getCommercialTags(state),
    pageType: getPageType(state),
    articleId: getArticleId(state),
});

export const injectVideoLogoEvent = {
    name: INJECT_VIDEO_LOGO,
    handlerCreator: (store: Store<AppState, AppActions>) => (params: InjectVideoLogoParams) => store.dispatch(injectVideoLogo(params)),
};

export const getPageDataEvent = {
    name: GET_PAGE_DATA,
    handlerCreator: (store: Store<AppState, AppActions>) => (callback: Function) => callback(createPageData(store.getState())),
};

export const injectArticleBlockByIndexArrayEvent = {
    name: INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY,
    handlerCreator: (store: Store<AppState, AppActions>) => (params: InjectArticleBlockByIndexArrayParams) => store.dispatch(injectArticleBlockByIndexArray(params)),
};

export const injectButtonToFooterLinksSectionEvent = {
    name: INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
    handlerCreator: (store: Store<AppState, AppActions>) => (params: InjectButtonParams) => store.dispatch(injectButtonToFooterLinksSection(params)),
};

export const injectButtonToMenuEvent = {
    name: INJECT_BUTTON_TO_MENU,
    handlerCreator: (store: Store<AppState, AppActions>) => (params: InjectButtonParams) => store.dispatch(injectButtonToMenu(params)),
};
